import { type Color, type ColorSpace } from 'react-aria-components'
import { CustomizeColor } from './customize-color'
import { CustomizeDarkMode } from './customize-dark-mode'
import { CustomizeFormat } from './customize-format'
import { CustomizeIconName } from './customize-icon-name'
import { CustomizeStrokeWidth } from './customize-stroke-width'
import { Divider } from './divider'

export function CustomizePanel({
	strokeWidth,
	setStrokeWidth,
	color,
	setColor,
	colorSpace,
	setColorSpace,
	hideColorStroke = false,
}: {
	strokeWidth: string
	setStrokeWidth: (strokeWidth: string) => void
	color: Color
	setColor: (color: Color) => void
	colorSpace: ColorSpace | 'hex'
	setColorSpace: (colorSpace: ColorSpace | 'hex') => void
	hideColorStroke?: boolean
}) {
	return (
		<div className="w-[330px] p-4">
			<CustomizeFormat />

			<Divider className="my-3.5" />

			<CustomizeIconName />

			<Divider className="my-3.5" />

			<CustomizeDarkMode />

			{!hideColorStroke && (
				<>
					<Divider className="my-3.5" />

					<CustomizeColor
						color={color}
						setColor={setColor}
						colorSpace={colorSpace}
						setColorSpace={setColorSpace}
					/>

					<Divider className="my-3.5" />

					<CustomizeStrokeWidth
						strokeWidth={strokeWidth}
						setStrokeWidth={setStrokeWidth}
					/>
				</>
			)}
		</div>
	)
}
